export default __webpack_public_path__ + "atomic/_patterns/02-molecules/header-quick-links/_header-quick-links.twig";